import React from 'react';
import './Sec1.css';

const Bundle = () => (
    <div>
        <br /><br />
        <h2>Bundle Discounts available with PD Fiber</h2>
        <p>
            Bundle Discounts are as follows:
        </p>
        <ul>
            <li>Purchase any PD Fiber residential internet package with Home phone service and receive a $10 per month discount on your bill.</li>
            <li>Purchase any PD Fiber commercial internet package with Business phone service and receive a $10 per month discount on your bill.</li>
        </ul>
    </div>
);

export default Bundle;


// WEBPACK FOOTER //
// ./src/components/sections/bundle.js